var map = {
	"./1.jpg": [
		2959,
		959
	],
	"./2.jpg": [
		7602,
		602
	],
	"./3.jpg": [
		2339,
		339
	],
	"./4.jpg": [
		5583,
		583
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5364;
module.exports = webpackAsyncContext;